import { useState } from "react"
import Header from "../components/Header"
import { Box } from "@mui/material"
import ModelEditForm from "../components/ModelEditForm"
import { spacing } from "../pages/services/styleServices"

const styles = {
  pageContent: {
    margin: spacing(1),
    padding: spacing(1),
  },
}

const ModelEdit = (props) => {
  const [title, setTitle] = useState("AI Designer")

  return (
    <Header title={title}>
      <Box sx={styles.pageContent}>
        <ModelEditForm {...props} setTitle={setTitle} />
      </Box>
    </Header>
  )
}

export default ModelEdit
